import React, { useState, useEffect } from 'react';
import './Modal.scss';


const Modal = ({ children, onClose, isOpen, withCross = true, className: propClassName = '', ...other }) => {
  const [isModalOpen, setIsModalOpen] = useState(isOpen);
  // Sync internal open state with prop changes
  useEffect(() => {
    console.log('Modal isOpen prop changed:', isOpen);
    setIsModalOpen(isOpen);
  }, [isOpen]);

  const handleClose = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsModalOpen(!isModalOpen)
    if (onClose) onClose()
  }
  const className = `modal-window ${propClassName}`

  return (
    <>
      {isModalOpen ? (
        <div className='modal-overlay'>
          <div className={className} {...other}>
            {withCross && <i className="material-icons clickable modal__close" onClick={handleClose}>close</i>}
            {children}
          </div>
        </div>
      ) : null}
    </>
  );
}

export default Modal